<section id="solutions" class="courses-area bg-fafafb">
    <div class="container">
        <div class="section-title" *ngFor="let sectionTitleContent of sectionTitle;">
            <span class="sub-title"><img src="https://imgvid.blob.core.windows.net/imgvid/star-icon.png" alt="image"> {{sectionTitleContent.title}}</span>
            <h2>{{sectionTitleContent.paragraphText}}</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let coursesContent of singleCoursesBox;">
                <div class="single-courses-box">
                    <div class="courses-image">
                        <a routerLink="/{{coursesContent.link}}" class="d-block image">
                            <img [src]="coursesContent.courseImg" alt="image">
                        </a>
                    </div>

                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                            <mat-icon style="margin-right: 12px">{{coursesContent.authorImg}}</mat-icon> <span>{{coursesContent.authorName}}</span>
                        </div>

                        <h3><a routerLink="/{{coursesContent.link}}">{{coursesContent.title}}</a></h3>
                        <p>{{coursesContent.paragraphText}}</p>

                        <ul class="courses-box-footer d-flex justify-content-between align-items-center">
                            <li>
                                {{coursesContent.studentApply}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="vector-shape6"><img src="https://imgvid.blob.core.windows.net/imgvid/vector-shape6.png" alt="image"></div>
</section>